import React, { useEffect, useState } from 'react'
import { Form } from 'semantic-ui-react';
import HotelsDropDown from '../../components/shared/HotelsDropDown';
import { useTextResources } from '../../language';
import GridSearchTemplate from '../GridSearchTemplate';
import { AccountingSystem, Hotels } from '../../api/services/next'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { onError, onSuccess } from '../../components/shared/messages';
import { MenuActions } from '../../components/shared/constants';
import { useLoader } from '../../hooks/useLoader';
import { EditModal } from './editModal';
import TransactionsDropDown from '../../components/shared/TransactionsDropDown';
import EntityTypesDropDown from '../../components/shared/EntityTypesDropDown';
import { TransactionCode } from '../../api/services/next';
import { EntityType } from '../../components/shared/constants';
import { GetRooms } from '../../api/services/pms';
import { GetWings } from '../../api/services/organization';
import { GetMarketSegments } from '../../api/services/pms';
import { RoomTypes } from '../../api/services/next';
import { onUpdateGridHandler } from '../../components/GridPanel/utility';

export const AccountingSystemMappingPage = () => {
    const text = useTextResources()
    const loader = useLoader()
    const [OrignalData, setOrignalData] = useState([])
    const [spec, setSpec] = useState([])
    const [hotels, setHotels] = useState([])
    const [data, setData] = useState([])
    const [transaction, setTransaction] = useState([]);
    const [roomsData, setRoomsData] = useState([]);
    const [roomsTypeData, setRoomsTypeData] = useState([]);
    const [wingsData, setWingsData] = useState([]);
    const [marketSegmentData, setMarketSegmentData] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const [hotelsData, transactionData, rooms, wings, marketSegment, roomTypes] = await Promise.all([
                    Hotels.GetHotels(),
                    TransactionCode.GetTransactionCode({
                        IsDebit: true,
                        IsActive: true
                    }),
                    GetRooms(),
                    GetWings(),
                    GetMarketSegments(),
                    RoomTypes.GetRoomTypes()
                ]);
                setHotels(hotelsData);
                setTransaction(transactionData);
                setRoomsData(rooms);
                setWingsData(wings);
                setMarketSegmentData(marketSegment);
                setRoomsTypeData(roomTypes)
            } catch (error) {
                onError(error);
            }
        })();
      
    }, []);


    const save = () => {
        (async () => {
            try {
                loader(true)
                const deleted = OrignalData.filter(val => !data.find(d => d.Id === val.Id)).map(m => m.Id)
                await AccountingSystem.PostTransactionCodeAccountingNumberMapping({ dtos: data, deletedIds: deleted })
                if ((data.length + deleted.length) > OrignalData.length) {
                    const updatedData = await AccountingSystem.GetTransactionCodeAccountingNumberMapping(spec)
                    setData(updatedData)
                    setOrignalData(updatedData);
                }
                else
                    setOrignalData(data)
                onSuccess()
            } catch (error) {
                onError(error)
            } finally {
                loader(false)
            }
        })()
    }

    useEffect(() => {
        if (window.optima?.commands) {
            window.optima.commands.unsubscribe(MenuActions.save);
            window.optima.commands.subscribe(MenuActions.save, save);
        }
    }, [save]);

    const onUpdate = (added, changed, deleted) => {
        const updated = onUpdateGridHandler(data, added, changed, deleted)
        setData(updated)
    }

    const hotelFormatter = ({ value }) => {
        const hotel = hotels.find(x => x.Id == value)
        return hotel?.Name || ''
    }
    const transactionFormatter = ({ value }) => {
        const t = transaction.find(x => x.Id == value)
        return t?.Name || ''
    }
    const entityTypeFormatter = ({ value }) => {
        return (
            Object.keys(EntityType).find(
                (type) => EntityType[type] === value
            ) || ''
        );
    };
    const entityFormatter = ({ row: { EntityTypeId, EntityId } }) => {
        const entity = {
            [EntityType.Room]: roomsData.find((v) => v.Id === EntityId),
            [EntityType.RoomType]: roomsTypeData.find((v) => v.Id === EntityId),
            [EntityType.Wings]: wingsData.find((v) => v.Id === EntityId),
            [EntityType.MarketSegment]: marketSegmentData.find((v) => v.Id === EntityId),
        }[EntityTypeId];
        return entity?.Name || '';
    };

    const gridOptions = {
        search: {
            title: text("AccountingSystemMapping"),
            fields: [
                <Form.Field control={HotelsDropDown} clearable label={text("Hotel")} key="HotelId" placeholder={text('All')} />,
                <Form.Field control={EntityTypesDropDown} clearable label={text("EntityType")} key="EntityTypeId" entityTypeIds={[EntityType.Room, EntityType.RoomType,EntityType.Wings,EntityType.MarketSegment]} placeholder={text('All')} />,
                <Form.Field control={TransactionsDropDown} clearable label={text("Transaction")} key="TransactionId" spec={{ IsDebit: true, IsActive: true }} placeholder={text('All')} />
            ],
            api: AccountingSystem.GetTransactionCodeAccountingNumberMapping,
            searchOnLoad: true
        },
        grid: {
            columns: [
                { name: 'HotelId', title: text("Hotel"), formatter: hotelFormatter },
                { name: 'EntityTypeId', title: text("EntityType"), formatter: entityTypeFormatter },
                { name: 'EntityId', title: text("Entity"), formatter: entityFormatter },
                { name: 'TransactionCodeId', title: text("TransactionCode"), formatter: transactionFormatter },
                { name: 'AccountingSystemNum', title: text("AccountingSystemNum") },

            ],
            cacheId: 'AccMappingPage',         
            customOptions:{
                hidden:{
                hiddenColumns: [ {columnName: 'Id'}]
                },
                group: {},
                sort: {}
            },
            editable: {
                allowAdd: true,
                allowDelete: true,
                allowEdit: true,
                modalEditor: {
                    modal: EditModal,
                    props: {
                        data,
                        hotels,
                        transaction,
                        roomsData,
                        roomsTypeData,
                        wingsData,
                        marketSegmentData
                    },
                },
            }
        }
    }
    return (
        <div style={{ flexDirection: 'column' }}>
            <GridSearchTemplate
                options={gridOptions}
                onGridUpdate={onUpdate}
                onSearchComplete={data => { setData(data); setOrignalData(data) }}
                onSearchChange={setSpec}
                data={data}
            />
        </div>
    );

}